<template>
    <li class="list-item" ref="container" :class="{active}" @click="$emit('itemClicked', id)">
        <div class="app-icon">
            <img :src="icon" :alt="name">
            <span class="platform-icon-wrap">
                <IconBase
                    v-if="platformIcon"
                    :iconName="platformIcon"
                    :iconColor="consts.COLORS.LIGHT_700"
                    display="flex"
                    height="10"
                    width="8"
                 />
            </span>
        </div>
        <div class="app-title">
            <Tooltip :text="name" :preventOverflow="false" class="app-name-container font-5">
                <span class="app-name">{{ name }}</span>
            </Tooltip>
            <small class="app-platform font-7">
                {{ platform }}
            </small>
        </div>
        <div class="app-meta">
            <IconBase
                v-if="abIcon"
                :iconName="abIcon"
                display="flex"
                :iconColor="consts.COLORS.LIGHT_700"
                width="24"
                height="18"
            />
            <div class="no-networks font-7" v-if="noNetworks">
                (No Networks)
            </div>
        </div>
    </li>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import Tooltip from 'components/Tooltip/Tooltip.vue';

export default {
    name: 'AppListItem',
    components: { Tooltip, IconBase },
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        platform: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        hasAB: {
            type: Boolean,
            default: false
        },
        hasBiddingTest: {
            type: Boolean,
            default: false
        },
        hasQuickAB: {
            type: Boolean,
            default: false
        },
        noNetworks: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        abIcon() {
            if (this.hasAB) {
                return 'abColorIcon';
            }

            if (this.hasBiddingTest || this.hasQuickAB) {
                return 'quickABColorIcon';
            }

            return '';
        },
        platformIcon() {
            const platform = (this.platform || '').toLowerCase();
            return ['ios', 'android'].includes(platform)
                ? `${platform}Icon`
                : null;
        },
        consts: () => consts
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.scss";

.list-item {
    // background color of selected item
    $active-bg-color: $light-100;

    position: relative;
    display: flex;
    height: 60px;
    padding: 0 10px;
    align-items: center;
    border-bottom: $border;
    border-left: 3px solid transparent;
    cursor: pointer;

    &.active {
        background: $active-bg-color;
        border-left: 3px solid $primary;
        .platform-icon-wrap {
            background: $active-bg-color;
        }
    }

    &:hover {
        background: $active-bg-color;
        .platform-icon-wrap {
            background: $active-bg-color;
        }
    }
}

.app-icon {
    display: flex;
    position: relative;

    img {
        width: 32px;
        height: 32px;
        border-radius: 4px;
    }

    .platform-icon-wrap {
        position: absolute;
        background-color: $white;
        border-radius: 10px;
        width: 14px;
        height: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        right: -6px;
        bottom: -6px;
    }
}

.app-title {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    min-width: 0; // truncated text fix - https://css-tricks.com/flexbox-truncated-text

    .app-name-container {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: initial;
        padding-right: 30px;
    }

    .app-platform {
        color: $light-800;
        display: block;
        line-height: 1;
    }
}

.app-meta {
    position: absolute;
    right: 11px;
    bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .no-networks {
        color: $light-800;
        margin-bottom: -2px;
    }
}
</style>
